// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"MO-z","categoryName":"NO-z","categoryNameSearchHeader":"OO-z","categoryContent":"PO-z","bottomAligned":"QO-z","image":"RO-z","imageNoBackground":"SO-z"};